module.exports = __webpack_public_path__ + "img/boiler1.153e7161.png";